import { SuitabilityAction } from './suitability.action';
import { createSelector } from '@ngrx/store';
import { SuitabilityProfileModel } from '../../models/suitability/suitabilityProfile.model';
import { InitializerAction } from '../initializer/initiliazer.action';

export class SuitabilityState {
    public questions: any[];
    public answers: any[];
    public pending: boolean;
    public profile: SuitabilityProfileModel;
    public profilePending: boolean;
    public pendingSaving: number;
    public pendingUpdating: number;
    public error: null;
    public data: any[];
    public answersStep: any[];
    public guidedSaleProfile: any;
    public usersAnswers: any[];
}

export const initialGenericState: SuitabilityState = {
    questions: [],
    answers: [],
    profile: null,
    profilePending: false,
    pending: false,
    error: null,
    pendingSaving: 0,
    pendingUpdating: 0,
    data: [],
    answersStep: [],
    guidedSaleProfile: null,
    usersAnswers: [],
};

export function SuitabilityReducer(state: SuitabilityState = initialGenericState, action: any) {

    switch (action.type) {

        /**
         * Quanto ao questionário
         */

        case SuitabilityAction.getQuestions:
            return {...{}, ...state, ...{pending: true, error: null}};

        case SuitabilityAction.getQuestionsSuccess:
            return {...{}, ...state, ...{pending: false, error: null, questions: action.payload}};

        case SuitabilityAction.getQuestionsError:
            return {...{}, ...state, ...{pending: false, error: action.payload}};

        case SuitabilityAction.getQuestion:
            return {...{}, ...state, ...{pending: true, error: null}};

        case SuitabilityAction.getQuestionSuccess:
            return {...{}, ...state, ...{pending: false, error: null, data: action.payload}};

        case SuitabilityAction.getQuestionError:
            return {...{}, ...state, ...{pending: false, error: action.payload}};

        case SuitabilityAction.getAnswers:
            return {...{}, ...state, ...{pending: true, error: null}};

        case SuitabilityAction.getAnswersSuccess:
            return {...{}, ...state, ...{pending: false, error: null, answers: action.payload}};

        case SuitabilityAction.getAnswersError:
            return {...{}, ...state, ...{pending: false, error: action.payload}};

        /**
         * Quanto ao usuário
         */

        case SuitabilityAction.getProfile:
            return {...{}, ...state, ...{profilePending: true, error: null}};

        case SuitabilityAction.getProfileSuccess:
            return {...{}, ...state, ...{ profile: action.payload, profilePending: false, error: null}};

        case SuitabilityAction.getProfileError:
            return {...{}, ...state, ...{profilePending: false, error: action.payload}};

        case SuitabilityAction.guidedSale:
            return {...{}, ...state, ...{ pending: true, error: null}};

        case SuitabilityAction.guidedSaleSuccess:
            return {...{}, ...state, ...{ guidedSaleProfile: action.payload, pending: false, error: null }};

        case SuitabilityAction.guidedSaleError:
            return {...{}, ...state, ...{ pending: false, error: action.payload}};

        case SuitabilityAction.getUserAnswers:
            return {...{}, ...state, ...{pending: true, error: null}};

        case SuitabilityAction.getUserAnswersSuccess:
            return {...{}, ...state, ...{ usersAnswers: action.payload, pending: false, error: null}};

        case SuitabilityAction.getUserAnswersError:
            return {...{}, ...state, ...{pending: false, error: action.payload}};

        // update user answers (sem fazer o suitability)
        case SuitabilityAction.updateUserAnswers:
            return {...{}, ...state, ...{pendingUpdating: state.pendingUpdating + 1, error: null }};

        case SuitabilityAction.updateUserAnswersSuccess:
            return {...{}, ...state, ...{pendingUpdating: state.pendingUpdating - 1, data: {...state.data, ...action.payload}}};

        case SuitabilityAction.updateUserAnswersError:
            return {...{}, ...state, ...{pendingUpdating: state.pendingUpdating - 1, error: action.payload}};

        case SuitabilityAction.answerStep:
            return {...{}, ...state, ...{ pending: true, error: null }};

        case SuitabilityAction.answerStepSuccess:
            let answer;
            let answerIndex;
            if (Array.isArray(action.payload)) {
                answer = [...[], ...state.answersStep, ...action.payload].reduce((acumulator, current) => {
                    const index = [...acumulator].findIndex((a) =>
                            a.subQuestionID ? a.subQuestionID === current.subQuestionID : a.questionID === current.questionI);
                    const unique = index < 0;
                    return unique ? [...acumulator, current] : [...acumulator];
                }, []);
            } else {
                answer = [...[], ...state.answersStep];
                answerIndex = state.answersStep.findIndex((a) =>
                    a.subQuestionID ? a.subQuestionID === action.payload.subQuestionID : a.questionID === action.payload.questionID);
                if (answerIndex > -1) answer.splice(answerIndex, 1);
                answer.push(action.payload);
            }
            return {...{}, ...state, ...{ pending: false, answersStep: [ ...[], ...answer] }};

        case SuitabilityAction.answerStepError:
            return {...{}, ...state, ...{ pending: false, error: action.payload} };

        case SuitabilityAction.clearAnswerStepSuccess:
            return {...{}, ...state, ...{ answersStep: [] }};

        case InitializerAction.resetUserRelatedData:
            return {
                ...state,
                ...{
                    answers: initialGenericState.answers,
                    profile: initialGenericState.profile,
                    answersStep: initialGenericState.answersStep,
                    guidedSaleProfile: initialGenericState.guidedSaleProfile,
                    usersAnswers: initialGenericState.usersAnswers,
                },
            };

        default:
            return state;
    }

}

// //selectors
// const filterQuestion = (state: SuitabilityState) => {
//     let question = state.questions.find(el => el.in)
// }
// const getSuitabilityState = (state: SuitabilityState) => state;
// export const getSuitabilityQuestion = (code: string) => createSelector(getSuitabilityState, filterQuestion);
